/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_FeaturedInputs */

const en_status_featured = /** @type {(inputs: Status_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const es_status_featured = /** @type {(inputs: Status_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Status_FeaturedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_featured = /** @type {((inputs?: Status_FeaturedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_FeaturedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_featured(inputs)
	return es_status_featured(inputs)
});